import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import Dashboard from "@/pages/Dashboard";
import { ThemeProvider } from "styled-components";
import Theme from "./utils/theme";
import { PageWrapper } from "./layout/PageWrapper";
import SignUp from "./pages/SignUp";
import SignIn from "./pages/SignIn";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import Profile from "./pages/Profile";
import { UserProvider } from "./context/UserContext";
import { ProtectedRoutesProvider } from "./context/ProtectRoutesContext";
import ForgotPassword from "./pages/ForgotPassword";
import PasswordRecovery from "./pages/PasswordRecovery";
import Challenges from "./pages/Challenges";
import Courses from "./pages/Courses";
import ChallengeSubmission from "./pages/ChallengeSubmission";
import { QueryClientProvider } from "react-query";
import { queryClient } from "./services/react-query";
import { ProfileInfoProvider } from "./context/ProfileInfoContext";
import { StagesProvider } from "./context/StagesContext";
import { RealityProvider } from "./context/RealityContext";
import TagManager from "react-gtm-module";
import { realityInfo } from "./utils/realityInfo";
import Regulation from "./pages/Regulation";
import { LocalStorageProvider } from "./context/LocalStorageContext";
import { SessionDialogsProvider } from "./context/SessionDialogsContext";
import { LoaderProvider } from "./context/LoaderContext";
import { RedirectProvider } from "./context/RedirectContext";
// import { Box } from "@mui/material";
// import Text from "./components/Text";

// GTM loads tags that POST to server-side tagging (GA); 503 on tagging URL is fixed in GTM/Cloud — not in this app.
// VITE_ENABLE_GTM=true: load GTM in dev. VITE_DISABLE_GTM=true: skip GTM in prod (e.g. while SGTM is down).
const shouldLoadGtm =
  Boolean(realityInfo.gtmId) &&
  import.meta.env.VITE_DISABLE_GTM !== "true" &&
  (import.meta.env.PROD || import.meta.env.VITE_ENABLE_GTM === "true");

if (shouldLoadGtm) {
  TagManager.initialize({
    gtmId: realityInfo.gtmId,
  });
}

function App() {
  // return (
  //   <Box
  //     display="flex"
  //     flexDirection="column"
  //     flex={1}
  //     justifyContent="center"
  //     alignItems="center"
  //     height="100vh"
  //   >
  //     <Text textAlign="center" fontSize="25px" fontWeight="800">
  //       Estamos realizando melhorias! 🚧
  //     </Text>
  //     <Text textAlign="center" fontSize="20px">
  //       <br /> No momento, nosso site está passando por uma manutenção para
  //       oferecer a você uma experiência ainda melhor. Voltamos em breve!
  //       Agradecemos sua compreensão e paciência.
  //     </Text>
  //   </Box>
  // );

  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={Theme}>
        <BrowserRouter
          future={{
            v7_startTransition: true,
            v7_relativeSplatPath: true,
          }}
        >
          <LoaderProvider>
            <RealityProvider>
              <LocalStorageProvider>
                <UserProvider>
                  <StagesProvider>
                    <SessionDialogsProvider>
                      <ProfileInfoProvider>
                        <RedirectProvider>
                          <ProtectedRoutesProvider>
                            <PageWrapper>
                              <Routes>
                                <Route
                                  path="/dashboard"
                                  element={<Dashboard />}
                                />
                                <Route path="/profile" element={<Profile />} />
                                <Route
                                  path="/complete-profile"
                                  element={<Navigate to="/dashboard" replace />}
                                />
                                <Route
                                  path="/challenges"
                                  element={<Challenges />}
                                />
                                <Route
                                  path="/challenges/:type/:id"
                                  element={<ChallengeSubmission />}
                                />

                                <Route path="/courses" element={<Courses />} />
                                <Route
                                  path="/regulation"
                                  element={<Regulation />}
                                />

                                <Route path="/sign-up" element={<SignUp />} />
                                <Route
                                  path="/sign-up/:realityId"
                                  element={<SignUp />}
                                />
                                <Route path="/sign-in" element={<SignIn />} />
                                <Route
                                  path="/forgot-password"
                                  element={<ForgotPassword />}
                                />
                                <Route
                                  path="/password-recovery"
                                  element={<PasswordRecovery />}
                                />
                              </Routes>
                            </PageWrapper>
                          </ProtectedRoutesProvider>
                        </RedirectProvider>
                      </ProfileInfoProvider>
                    </SessionDialogsProvider>
                  </StagesProvider>
                </UserProvider>
              </LocalStorageProvider>
            </RealityProvider>
          </LoaderProvider>

          <ToastContainer />
        </BrowserRouter>
      </ThemeProvider>
    </QueryClientProvider>
  );
}

export default App;
